var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1488_82495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 11,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3335,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1488_82495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27015 7.33333C8.17634 7.33333 8.08426 7.31578 7.99391 7.28069C7.90386 7.24559 7.82635 7.19295 7.76141 7.12275L5.86717 5.29068C5.73007 5.15029 5.66339 4.98 5.66714 4.77981C5.67061 4.5799 5.74089 4.41325 5.878 4.27989C6.02232 4.1395 6.19912 4.0693 6.40838 4.0693C6.61765 4.0693 6.79084 4.1395 6.92795 4.27989L8.27015 5.5855L11.7339 2.20565C11.8782 2.07228 12.0533 2.00377 12.2591 2.00012C12.4646 1.99675 12.6395 2.06526 12.7838 2.20565C12.9282 2.34604 13.0003 2.51801 13.0003 2.72157C13.0003 2.92514 12.9282 3.0936 12.7838 3.22697L8.77888 7.12275C8.71394 7.19295 8.63644 7.24559 8.54638 7.28069C8.45603 7.31578 8.36396 7.33333 8.27015 7.33333Z",
    fill: "#13ACAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.960acfb3fe4777682f505dfe728c9c7f.svg";
export { ForwardRef as ReactComponent };